import { useApp } from "../context";
import { Heading, Table, CaseLink, Filters, Badge, NewCaseButton } from "../components/Bits";
import { money, expected, getPartner, collectionStatus, visibleCases } from "../lib/engine";

export default function LoanCases() {
  const { state, search, region } = useApp();
  return (
    <>
      <Heading title="Loan cases" description="Track each loan, disbursement and financial position.">
        <NewCaseButton />
      </Heading>
      <div className="card">
        <Filters />
        <Table testId="loan-cases-table"
          headers={["Case / tranche", "Borrower / DSA", "Bank / city", "Disbursement", "Expected commission", "Status"]}>
          {visibleCases(state, search, region).map(c => (
            <tr key={c.id} data-testid={`loan-row-${c.id}`}>
              <td><CaseLink c={c} /></td>
              <td><strong>{c.name}</strong><small>{getPartner(state, c).name}</small></td>
              <td>{c.bank}<small>{c.city}</small></td>
              <td className="number">{money(c.amount)}</td>
              <td className="number">{money(expected(c))}<small>{c.bankRate}%</small></td>
              <td><Badge text={collectionStatus(state, c)} testId={`loan-status-${c.id}`} /></td>
            </tr>
          ))}
        </Table>
      </div>
    </>
  );
}
